import type {FC} from 'react';
import {ResultsCount} from '~/GalleryPB/components/ResultsCount';
import {Typography} from '~library/atoms/Typography';
import {useMatchQuery} from '~library/hooks/useMatchQuery';
import {largishAndUp} from '~libSass/base/_exports.sass';

interface PageTitleProps {
  text: string;
  numTemplates: number;
}

export const PageTitle: FC<PageTitleProps> = ({text, numTemplates}) => {
  const {matches: largeScreens} = useMatchQuery(`(min-width: ${largishAndUp})`);

  return (
    <Typography
      className="gallery__gallery-title"
      variant="header3"
      as="h1"
      data-qa-id="galleryPageTitle"
    >
      {text}{' '}
      {largeScreens && numTemplates !== null && <ResultsCount numTemplates={numTemplates} inline />}
    </Typography>
  );
};
